module.exports = __webpack_public_path__ + "media/app/assets/hero-tbc-f19932db01561653e11b302e2f2327df.jpeg";